<template>
  <span class="send-flex-card">
    <toast-alert v-if="isSending" :isLoading="isLoading" :text="`แชร์สำเร็จ`"></toast-alert>
    <slot name="button"></slot>
  </span>
</template>
<script>
import ToastAlert from "../../../components/miniapp/global/ToastAlert.vue"
export default {
  components: {
    ToastAlert
  },
  data() {
    return {
      ott: "",
      flexData: [],
      isSending: false,
      isLoading: false,
      isProcessing: false
    }
  },
  props: {
    templateFlex: {
      type: Array,
      default: []
    },
    isPrepareCompleted: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    $route(to, from) {
      if (from.query.is_share) {
        // this.$router.push({ name: this.$route.name, query: this.$route.query });
        location.reload()
      }
      // if (!this.$route.query.is_share) {
      //   location.reload();
      // }
    },
    templateFlex(arr) {
      this.flexData = arr
    },
    async isPrepareCompleted(bool) {
      if (bool) {
        this.flexData = this.templateFlex
        await this.shareAssets()
        this.$emit("reset-fact")
      }
    }
  },
  mounted() {
    this.flexData = this.templateFlex
  },
  methods: {
    sendShare() {
      try {
        this.isLoading = true
        this.isSending = true
        setTimeout(async () => {
          await this.$liff.shareTargetPicker(this.flexData)
          this.isSending = false 
          // detect when user comback from share target picker
          window.addEventListener("focus", () => {
            this.isLoading = false
            this.isSending = true
            setTimeout(() => {
              this.isSending = false
            }, 2000)
          })
        }, 1000)
      } catch (err) {
        console.error("Failed to launch ShareTargetPicker: ", err)
      }
    },
    async shareAssets() {
      let id = this.$route.query.id || ""
      let name = this.$route.query.name || ""

      if (id) {
        this.$router.push({
          name: this.$route.name,
          query: { id: this.$route.query.id, is_share: true }
        })
      } else {
        this.$router.push({
          name: this.$route.name,
          query: { name: this.$route.query.name, is_share: true }
        })
      }

      this.$liff.ready.then(async () => {
        if (this.$liff.isLoggedIn() && this.$liff.isApiAvailable("shareTargetPicker")) {
          this.sendShare()
        } else {
          const res = await this.$liff.login()
          console.log(res)
          res ? this.sendShare() : null
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.send-flex-card {
  cursor: pointer;
  a {
    vertical-align: middle;
  }
  i {
    font-size: 18px;
    color: $color-light-grey-2;
    vertical-align: top;
  }
}
</style>